'use client';

import dynamic from 'next/dynamic';
import React from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

import filmRollAnimation from '@/assets/filmRollLoading.json';

// @lottiefiles/react-lottie-player touches `document` at import time, which crashes SSR (client
// components are still server-rendered for the initial HTML). Load it client-only so it never runs
// on the server.
const Player = dynamic(() => import('@lottiefiles/react-lottie-player').then((mod) => mod.Player), {
    ssr: false
});

export type ListLoadingAnimationProps = {
    className?: string;
    classNamePlayer?: string;
};

function ListLoadingAnimation(props: ListLoadingAnimationProps): React.JSX.Element {
    const { className, classNamePlayer } = props;
    return (
        <div className={cn(className || 'py-38', ' ')}>
            <Player
                autoplay
                loop
                src={filmRollAnimation}
                className={`${classNamePlayer}`}
            />
        </div>
    );
}

export default ListLoadingAnimation;
